import { Navigate, useLocation } from 'react-router-dom'

/** Keep bookmarked report filters when forwarding the former standalone route. */
export default function CampaignReportingRedirect() {
  const location = useLocation()
  const search = new URLSearchParams(location.search)
  search.set('tab', 'reporting')
  return <Navigate to={{ pathname: '/campaigns', search: `?${search}`, hash: location.hash }} replace />
}
